import React from "react";
import { ToastContainer } from "react-toastify";
import "../Admin/table.css";
import ViewMeetingComponent from "./ViewMeetingComponent";

const ViewMahilaSabhaMeeting = () => {
  return (
    <>
      <style> {`.MuiTablePagination-actions svg {visibility: visible !important;fill: #212128;} `}</style>
      <div className="container-fluid" style={{ height: "91vh" }}>
        <div style={{ padding: '16px', marginTop: "-16px", marginLeft: "-3px", marginRight: "-12px", }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>View Meeting Data For Mahila Sabha</h2>
        </div>

        <div style={{ overflowX: "auto", maxHeight: "100vh", marginTop: "20px", scrollbarWidth: "none", msOverflowStyle: "none", }}>
          <ViewMeetingComponent meeting_type="mahila_sabha" />
        </div>

        <ToastContainer />
      </div>
    </>
  );
};

export default ViewMahilaSabhaMeeting;